import { InjectionToken } from "@angular/core";

export const PAYPAL_CLIENT_ID = new InjectionToken<string>('PaypalClientId');

export const PAYPAL_INNATELY_CLIENT_ID = new InjectionToken<string>('PaypalInnatelyClientId');
export const PAYPAL_INNATELY_VENDOR_CLIENT_ID = new InjectionToken<string>('PaypalInnatelyVendorClientId');